import { render, staticRenderFns } from "./CreateVoucher.vue?vue&type=template&id=2366866b&scoped=true&"
import script from "./CreateVoucher.vue?vue&type=script&lang=ts&"
export * from "./CreateVoucher.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2366866b",
  null
  
)

export default component.exports